// Helper centralisé — Affichage des durées pour les prestations de jeux PlayCity
// Règles métier (validation CEO) :
//   < 60             → "X min"
//   = 60, 120, 180…  → "XH"
//   > 60 avec reste  → "XHYY"
//   240              → "4H" + sous-libellé "½ journée"
//   480              → "8H" + sous-libellé "1 journée"

export const formatDuree = (minutes) => {
  const m = parseInt(minutes, 10);
  if (!m || m <= 0) return '';
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const rest = m % 60;
  if (rest === 0) return `${h}H`;
  return `${h}H${rest.toString().padStart(2, '0')}`;
};

export const getDureeSubLabel = (minutes) => {
  const m = parseInt(minutes, 10);
  if (m === 240) return '1/2 journée';
  if (m === 480) return 'Journée entière';
  return '';
};

// Génère un label complet pour panier / ventes : "1H30" ou "4H – ½ journée"
export const formatDureeFull = (minutes) => {
  const main = formatDuree(minutes);
  const sub = getDureeSubLabel(minutes);
  return sub ? `${main} – ${sub}` : main;
};
